export enum ROUTES {
  default = '/',
}
